import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

// Returns only the first instance of a product with a given id in the filtered list
var getUniqueFilteredProducts = function getUniqueFilteredProducts(filteredProducts) {
  return filteredProducts.filter(function (thisProduct, index) {
    return filteredProducts.findIndex(function (testProduct) {
      var _testProduct$node$pro, _thisProduct$node$pro;

      return ((_testProduct$node$pro = testProduct.node.product) === null || _testProduct$node$pro === void 0 ? void 0 : _testProduct$node$pro.id) === ((_thisProduct$node$pro = thisProduct.node.product) === null || _thisProduct$node$pro === void 0 ? void 0 : _thisProduct$node$pro.id);
    }) === index;
  });
};

var filterAndSort = function filterAndSort(_ref) {
  var products = _ref.products,
      filters = _ref.filters,
      sort = _ref.sort,
      filteringOrSorting = _ref.filteringOrSorting;
  // Filter products by the selected filters
  var filteredProducts = filteringOrSorting ? _toConsumableArray(products).filter(function (block) {
    return block.node.product !== null;
  }) : _toConsumableArray(products); // Check if color palette filter has been applied

  var filteredByColor = false; // Check if size filter has been applied

  var filteredBySize = false;
  filters.forEach(function (filt) {
    if (!filt.selected) {
      return;
    }

    filteredByColor = filteredByColor || filt.param === 'paletteFilter';
    filteredBySize = filteredBySize || filt.param === 'sizeFilter';
    filteredProducts = filteredProducts.filter(function (_ref2) {
      var product = _ref2.node.product;
      return filt.filter(product, filt.selected.value);
    });
  }); // Apply our sort

  if (sort.sort) {
    filteredProducts = filteredProducts.sort(sort.sort);
  } // If a sort also has a filter apply it


  if (sort.filter) {
    filteredProducts = filteredProducts.filter(function (product) {
      return sort.filter(product);
    });
  } // Show unique product list, when user filters by color or size


  var showUniqueProducts = filteredProducts.length > 1 && (filteredByColor || filteredBySize);
  var productsToDisplay = showUniqueProducts ? getUniqueFilteredProducts(filteredProducts) : filteredProducts;
  return productsToDisplay;
};

export default filterAndSort;